export interface Insets {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

const NONE: Insets = { top: 0, bottom: 0, left: 0, right: 0 };

/** Browsers lay the app out in the viewport; there is nothing to inset around. */
export function useInsets(): Insets {
  return NONE;
}
